// removed by extract-text-webpack-plugin
module.exports = {"overlay":"_2gadqwmLJ-LLe5KkGgptgT","hover-actions-container":"_2LvoHvlN_HIWdvqDqh6YLG","hover-actions":"_2OiJVxirqMTQ3f8SZYBL1f","hover-button":"_1qmi3JDyz6SoFVTmVhlMXx"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/Overlay.styl
// module id = 180
// module chunks = 0